import { NgModule } from '@angular/core';
import { PershingCoreModule } from '@pershing/pershing-core';
import { PershingCommonModule } from '@pershing/pershing-common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ErrorStateMatcher, MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ExchangeAgreementOverviewComponent } from './components/ExchangeAgreement/ExchangeAgreementOverview/exchange-agreement-overview.component';
import { ExchangeAgreementNonProfDisclosureComponent } from './components/ExchangeAgreement/ExchangeAgreementNpsd/exchange-agreement-npsd.component';
import { ExchangeAgreementNYSEPComponent } from './components/ExchangeAgreement/ExchangeAgreementNYSEP/exchange-agreement-nyse-p.component';
import { ExchangeAgreementNYSENPComponent } from './components/ExchangeAgreement/ExchangeAgreementNYSENP/exchange-agreement-nyse-np.component';
import { ExchangeAgreementNSDAQComponent } from './components/ExchangeAgreement/ExchangeAgreementNSDAQ/exchange-agreement-nsdaq.component';
import { ExchangeAgreementOPRAComponent } from './components/ExchangeAgreement/ExchangeAgreementOPRA/exchange-agreement-opra.component';
import { ExchangeAgreementConfirmComponent } from './components/ExchangeAgreement/ExchangeAgreementConfirm/exchange-agreement-confirm.component';
import { ExchangeAgreementConfirmLaterDialogComponent } from './components/ExchangeAgreement/ExchangeAgreementConfirmlaterDialog/exchange-agreement-confirmlater-dialog.component';
import { ExchangeAgreementDialogComponent } from './components/ExchangeAgreement/exchange-agreement-dialog.component';
import { ExchangeAgreementNavComponent } from './components/ExchangeAgreement/ExchangeAgreementNav/exchange-agreement-nav.component';

import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { PershingTradingCommonModule } from '@pershing/trading-common';
import { MatStepperModule } from '@angular/material/stepper';

const EXCHANE_AGREEMENT_COMPONENTS = [
    ExchangeAgreementOverviewComponent,
    ExchangeAgreementNonProfDisclosureComponent,
    ExchangeAgreementNYSEPComponent,
    ExchangeAgreementNYSENPComponent,
    ExchangeAgreementNSDAQComponent,
    ExchangeAgreementOPRAComponent,
    ExchangeAgreementConfirmComponent,
    ExchangeAgreementConfirmLaterDialogComponent,
    ExchangeAgreementNavComponent,
    ExchangeAgreementDialogComponent
];
@NgModule({
    imports: [
        // This will be moved to app specific
        // common module and appsepcific common module will be
        // imported here
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        MatCheckboxModule,
        MatDialogModule,
        MatSelectModule,
        MatStepperModule,
        MatTooltipModule,
        MatButtonModule,
        MatNativeDateModule,
        PershingCommonModule,
        PershingCoreModule,
        PershingTradingCommonModule
    ],
    declarations: [...EXCHANE_AGREEMENT_COMPONENTS],
    exports: [...EXCHANE_AGREEMENT_COMPONENTS,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatStepperModule],
    providers: [ErrorStateMatcher],
    entryComponents: [...EXCHANE_AGREEMENT_COMPONENTS]
})
export class ExchangeAgreementModule { }
